module.exports = __webpack_public_path__ + "media/my_images/search/next-19a4db5ce96f522702eaeaeff829ad93.svg";